import { useMemo } from 'react'
import { View } from 'react-native'

import { useAvatar, type TUseAvatarProps } from './useAvatar'

export type TAvatarProps = TUseAvatarProps

export const Avatar = ({ ref, ...props }: TAvatarProps) => {
  const { ImgComponent, src, alt, showFallback, getAvatarProps, getImageProps } = useAvatar({
    ...props,
  })

  const fallback = useMemo(() => {
    if (!showFallback && src) return null

    return (
      <View ref={ref} {...getAvatarProps()}>
        <ImgComponent
          {...getImageProps()}
          role="img"
          source={require('@/img/hozana_img_avatar_default.png')}
          alt={alt}
          style={{ width: '100%', height: '100%' }}
          placeholder={{ blurhash: 'LmLg9W-oNGt7~Cs.ofWC4:RkfRR*', isAnimated: true }}
        />
      </View>
    )
  }, [ImgComponent, alt, ref, getAvatarProps, getImageProps, showFallback, src])

  return (
    <View ref={ref} {...getAvatarProps()}>
      {src != null && !showFallback && (
        <ImgComponent {...getImageProps()} role="img" alt={alt} style={{ width: '100%', height: '100%' }} />
      )}
      {fallback}
    </View>
  )
}

Avatar.displayName = 'Avatar'
